
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

 class CartSelectVariant extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
     this.select.addEventListener('change', this.onSelectChange.bind(this.select));
  }
  onSelectChange(event) {
    event.preventDefault();
    event.stopPropagation();
    const currentEl = event.target;
    const cartItems = currentEl.closest('cart-items') ;
    let message = window.cartStrings.error;
    var line = currentEl.getAttribute("data-index");
    var len = $(`cart-items .cart-item`).length;
    var updatesObj = {};
    var changeItemId = parseInt($(this).find(`option:selected`).val());
    var oldItemId = currentEl.getAttribute("data-oldid");
    var tempId = 0;
    var tempQty = 0;
    var tempKey;
    var templineinex0 = parseInt(line)-1 ;
    cartItems.enableLoading(line);
    updatesObj[oldItemId] = 0;  
    if($(`cart-items .cart-item[data-idth="${changeItemId}"]`).length) {
        for(var i=len-1; i>=0 ; i--) {
            if(parseInt($(`cart-items .cart-item`).eq(i).attr(`data-idth`)) == changeItemId) {             
                tempQty = parseInt($(this).parents(".cart-item").find('input[name="updates[]"]').val()) + parseInt($(`cart-items .cart-item[data-idth="${changeItemId}"]`).attr(`data-qty`));
                if(window.limit_item[changeItemId] != null){
                  updatesObj[changeItemId] = window.limit_item[changeItemId]; 
                }else{
                  updatesObj[changeItemId] = tempQty;    
                }                      
            } else {
                tempId = parseInt($(`cart-items .cart-item`).eq(i).find(".item-variants-select option:selected").val()) || parseInt($(`cart-items .cart-item`).eq(i).attr(`data-idth`));
                tempQty = parseInt($(`cart-items .cart-item`).eq(i).find(`input[name='updates[]']`));
                if(changeItemId != tempId){
                  if(window.limit_item[tempId] != null){
                    updatesObj[tempId] = window.limit_item[tempId]; 
                  }else{
                    updatesObj[tempId] = tempQty; 
                  }
                }              
            }
        }
    }else{
        for(var i=len-1; i>=0 ; i--) {  
          tempId = parseInt($(`cart-items .cart-item`).eq(i).find(".item-variants-select option:selected").val()) || parseInt($(`cart-items .cart-item`).eq(i).attr(`data-idth`));
            tempQty = parseInt($(`cart-items .cart-item`).eq(i).find(`input[name='updates[]']`).val());
            if(window.limit_item[tempId] != null){
              updatesObj[tempId] = window.limit_item[tempId]; 
            }else{              
              updatesObj[tempId] = tempQty; 
               }
            if(templineinex0 == i){
            tempKey = $(`cart-items .cart-item`).eq(i).attr(`key`);
            updatesObj[tempKey] = 0;
        }
        }
    }
  fetch(`${routes.cart_update_url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({updates: updatesObj})
  })
.then((response) => {
    if (response.ok) {
      cartItems.onCartUpdate();
      cartItems.disableLoading(line);
      window.cart_proxy.isActive = true;
    } else {
      if (response.status === 422) {
        console.log("Inventory shortage!");
      }
      throw new Error("failed");
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });

  }
 }

 customElements.define('select-variant', CartSelectVariant);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    if(event.target.hasAttribute('custom-variants-selector')){
      console.log("is select variant");
    }else{
      this.validateQuantity(event);
    }   
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {  
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['.cart-count-bubble', '.drawer__header', '.sider-cart-top-count', '.drawer__inner-empty', 'cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['.cart-count-bubble', '.cart-items-js-contents', '.subtotal-content'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
       

        })
        .catch((e) => {
          console.error(e);
        });
    }
    window.cart_proxy.isActive = false;
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-empty',
        section: document.getElementById('cart-empty').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartitemlist = document.getElementById('main-cart-items');
        const cartFooter = document.getElementById('main-cart-footer');
        const CartEmptySection = document.getElementById('cart-empty');
        const cartbestsellerSection = document.getElementById('cart-bestseller'); 
        if (cartitemlist) cartitemlist.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        if(CartEmptySection) CartEmptySection.classList.toggle('hidden', parsedState.item_count != 0);
        if(cartbestsellerSection) cartbestsellerSection.classList.toggle('is-empty', parsedState.item_count === 0);
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        let local = window.location.href;
      if (local.indexOf("/cart") > 0) {
        fetch(`${routes.cart_url}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['.cart-count-bubble', '.cart-items-js-contents', '.subtotal-content', '#cart-empty .js-contents'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
          })
          .catch((e) => {
            console.error(e);
            window.location.reload();
          });
      }
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        window.cart_proxy.isActive = true;
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = !document.querySelector('cart-drawer')?.classList.contains('active') ? document.getElementById(`Line-item-error-${line}`) : document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    // 更新相关产品数量
    fetch(`${routes.cart_url}`).then((response) => response.text()).then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const selectors = ['.cart-count-bubble', '.cart-items-js-contents', '.subtotal-content', 'cart-drawer-items', '.cart-drawer__footer', '.drawer__heading', '.item-count'];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
    }).catch((e) => {
      console.error(e);
    });

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

